// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Atom_Cta from "./Atom_Cta.bs.js";
import * as Atom_Column from "./Atom_Column.bs.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Particle_Screen_Ds from "../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../particle/Particle_Spacer_Ds.bs.js";
import * as Molecule_ContentCollection_Css from "../molecule/Molecule_ContentCollection_Css.bs.js";

function Atom_Backlink$Internal(Props) {
  var href = Props.href;
  var variant = Props.variant;
  var onClick = Props.onClick;
  var dataAnchor = Props.dataAnchor;
  var label = Props.label;
  var tmp = {
    href: href,
    label: label,
    style: variant
  };
  if (dataAnchor !== undefined) {
    tmp.dataAnchor = dataAnchor;
  }
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement(Atom_Cta.Link.make, tmp);
}

var Internal = {
  make: Atom_Backlink$Internal
};

function Atom_Backlink(Props) {
  var href = Props.href;
  var label = Props.label;
  return React.createElement(Atom_Column.make, {
              blockSpace: Molecule_ContentCollection_Css.Backlink.blockSpace,
              children: React.createElement(Atom_Backlink$Internal, {
                    href: href,
                    variant: /* BackLink */3,
                    dataAnchor: true,
                    label: label
                  })
            });
}

function Atom_Backlink$Papa(Props) {
  var href = Props.href;
  var label = Props.label;
  var onClick = Props.onClick;
  var tmp = {
    href: href,
    variant: /* Papa */14,
    label: label
  };
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement(Atom_Backlink$Internal, tmp);
}

var Papa = {
  make: Atom_Backlink$Papa
};

function Atom_Backlink$Presse(Props) {
  var href = Props.href;
  var label = Props.label;
  var onClick = Props.onClick;
  var tmp = {
    href: href,
    variant: {
      TAG: /* Presse */16,
      _0: /* BackLink */5
    },
    label: label
  };
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement(Atom_Column.make, {
              blockSpace: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("S")),
              children: React.createElement(Atom_Backlink$Internal, tmp)
            });
}

var Presse = {
  make: Atom_Backlink$Presse
};

var make = Atom_Backlink;

export {
  Internal ,
  make ,
  Papa ,
  Presse ,
}
/* react Not a pure module */
